import { z } from 'zod';

/**
 * The response of dash-meta's `global-assistant/report-params`: one suggestion
 * per parameter value the prompt resolved to. dash-meta produces it, the
 * report-offer click consumes it, and the Playwright mocks and API tests
 * validate against it, so a change to the shape fails on every side at once.
 */
const reportParamResolvedSelectionSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    levelId: z.string(),
    rcid: z.number().optional(),
  })
  .strict();

const reportParamSuggestionSchema = z
  .object({
    parameterId: z.string(),
    displayName: z.string(),
    searchTerm: z.string(),
    resolvedSelection: reportParamResolvedSelectionSchema.nullable(),
    resolutionStatus: z.enum(['resolved', 'unresolved', 'rejected']),
    resolutionReason: z.string().optional(),
  })
  .strict();

export const reportParamSuggestionsSchema = z.array(
  reportParamSuggestionSchema
);

export type ReportParamResolvedSelection = z.infer<
  typeof reportParamResolvedSelectionSchema
>;

export type ReportParamSuggestion = z.infer<typeof reportParamSuggestionSchema>;

export type ReportParamResolutionStatus =
  ReportParamSuggestion['resolutionStatus'];
